const imageWithFocalPoint = {
  displayField: 'title',
  name: 'Image with Focal Point',
  description: null,
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'image',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'focalPoint',
      name: 'Focal point',
      type: 'Object',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'imageWithFocalPoint',
    version: 11,
    updatedAt: '2023-08-01T17:12:39.273Z'
  }
};
export default imageWithFocalPoint;